type Params = {
	propertyPrice: number;
	ratio: number;
	cap: number;
	step: number;
	rounding: "floor" | "nearest";
};

export const getMaxLoanValue = ({
	propertyPrice,
	ratio,
	cap,
	step,
	rounding,
}: Params) => {
	if (propertyPrice <= 0) {
		return 0;
	}

	const round = rounding === "floor" ? Math.floor : Math.round;
	const rounded = round((ratio * propertyPrice) / step) * step;

	return Math.min(rounded, cap);
};
